define(function(require, exports, module) {
    'use strict';

    const util = require('utils');
    const Class = require('Class');
    const AbstractProvider = require('common/addressLookupSwiss/sourceProviders/abstractProvider');

    module.exports = Class.create(AbstractProvider, {
        zipRegEx: /^[0-9]*$/,
        cityRegEx: /^([^0-9]*)$/,
        sortBy: '',
        searchText: '',

        /**
         * @override
         */
        prepareRequest: function(searchText, prevSearchResult) {
            const data = AbstractProvider.prototype.prepareRequest(searchText, prevSearchResult);
            const zipCode = this.zipRegEx.test(searchText) ? searchText : '';
            const townName = this.cityRegEx.test(searchText) ? searchText : '';
            this.sortBy = townName && 'city';
            this.searchText = searchText.toLowerCase();

            data.request = {
                ...data.request,
                Zipcode: zipCode,
                TownName: townName
            };

            return data;
        },

        /**
         * @override
         */
        isValid: function(searchText) {
            return searchText.length >= 2 && (this.zipRegEx.test(searchText) || this.cityRegEx.test(searchText));
        },

        /**
         * @override
         */
        sort: function(rows) {
            if (this.sortBy === 'city') {
                return rows.sort((row1, row2) => {
                    const city1 = row1.city.toLowerCase();
                    const city2 = row2.city.toLowerCase();

                    if (city1.includes(this.searchText) && !city2.includes(this.searchText)) {
                        return -1;
                    }

                    if (!city1.includes(this.searchText) && city2.includes(this.searchText)) {
                        return 1;
                    }

                    return util.predicate.stringPredicate(city1, city2);
                });
            }

            return rows.sort((row1, row2) => util.predicate.stringPredicate(row1.zip, row2.zip));
        },

        /**
         * @override
         */
        format: function(row) {
            return this.highlightResult(row.zip + ' ' + row.city);
        }
    });
});
